import React, { useEffect, useContext, useState } from 'react'
import RadioBox from '@/product/components/atoms/RadioBox'
import { useFormik } from 'formik'
import { mapData, dateFormatFunction } from '@/product/common/components'
import ReportDisplay from './display'
import { useHistory } from 'react-router-dom'
import CheckBox from '@/product/components/atoms/CheckBox'
import AuthContext from '@/product/context/auth/authContext'
import { useTranslation } from 'react-i18next'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import ReportContext from '@/product/context/report/reportContext'
import CustomCommonContext from '@/custom/context/common/commonContext'
import AuctionContext from '@/product/context/auction/auctionContext'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import AlertContext from '@/product/context/alert/alertContext'

const ReportComponent = (props) => {
    const history = useHistory()
    const { t } = useTranslation()
    const { setAlert } = useContext(AlertContext)
    const reportContext = useContext(ReportContext)
    const auctionContext = useContext(AuctionContext)
    const [resetForm, setResetForm] = React.useState(false)
    const [reportsData, setReportsData] = React.useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const { allBusinessCategory } = useContext(CustomCommonContext)
    const { all_auctions, getAllAuctions } = auctionContext
    const [report, setReport] = React.useState(null)
    const [isTemplate, setIsTemplate] = React.useState(true)
    const [templateId, setTemplateId] = useState(0)
    const [reportName, setReportName] = React.useState('')

    const {
        reports_data,
        report_templates,
        getAllReportDisplay,
        getAllReportDownload,
        reportTemplateAction,
        responseStatus: responseStatusReport,
        clearResponse: clearResponseReport,
        getAllReportTemplates,
        deleteReportTemplate,
    } = reportContext

    const [manage, setManage] = React.useState({
        popup: false,
    })

    const toggleFullScreenPopup = (popup) => {
        console.log(popup, 'poppp')
        setManage({ popup: popup })
    }

    const [tableBody, setTableBody] = useState([])

    const formikAuction = useFormik({
        initialValues: {
            limit: 2000,
            page: 1,
            orderby: ' ac.id ',
            order: ' desc ',
            auctionFetch: props.auctionFetch || false,
            filters: {},
        },
        enableReinitialize: false,
        onSubmit: (values) => {
            setIsLoading(true)
            getAllAuctions(values, 'reportsAuction')
        },
    })

    useEffect(() => {
        if (all_auctions.from === 'reportsAuction') {
            setTableBody(
                all_auctions.records.length ? all_auctions.records : []
            )
        }
        setIsLoading(false)
    }, [all_auctions])

    const formik = useFormik({
        initialValues: {
            ...props.initialValues,
            single_date: dateFormatFunction(new Date()),
        },
        validateOnBlur: false,
        validationSchema: props.validationSchema,
        onSubmit: (values) => {
            setIsLoading(true)
            values.page = props.initialValues?.page || 1
            values.limit = props.initialValues?.limt || 20
            values.replaceName = props.replaceName ? props.replaceName : {}
            values.joinBuynow = true

            values.report = reportName ? reportName : values.report
            if (
                props.agencyFilter &&
                user?.emp_type !== 'super_admin' &&
                filteredAgencies.length &&
                agencyReports.includes(values.report)
            ) {
                if (formik.values?.filters?.agency_id?.value.length <= 0) {
                    setAlert('Please Select Agency', 'error')
                    return false
                }
            }
            if (values.template) {
                reportTemplateAction(values)
                formik.values.template = false
                //setGenerateReport(false)
                return false
            }
            if (
                props.customField &&
                props.customField.includes(values.report) &&
                values.action === 'download'
            ) {
                let formFields = props.formFields
                let fieldsToSend = formFields
                fieldsToSend = fieldsToSend.filter(
                    (field) =>
                        field.group.indexOf(values.report.toString()) !== -1
                )
                fieldsToSend = fieldsToSend.filter((field) =>
                    values.fields.includes(field.field)
                )

                let changedValues = { ...values, fields: fieldsToSend }
                formik.setSubmitting(true)
                getAllReportDownload(changedValues)
            } else {
                formik.setSubmitting(true)
                const dropDownFields = props.dropDownFields
                values.dropDownFields = dropDownFields

                if (values.action === 'display') {
                    // formik.values.searchterm = ''
                    getAllReportDisplay(values)
                    toggleFullScreenPopup(true)
                } else {
                    getAllReportDownload(values)
                }
            }
        },
    })

    useEffect(() => {
        toggleFullScreenPopup(false)
        setResetForm(!resetForm)
        setReportsData(null)
        getAllReportTemplates()
    }, [])

    useEffect(() => {
        if (responseStatusReport) {
            if (responseStatusReport.from === 'createTemplate') {
                if (responseStatusReport.status === 'success') {
                    setAlert('Created Successfully', 'success')
                    formik.values.template_name = ''
                    formik.values.template = false
                    formik.values.report = 'active_user_management'
                    getAllReportTemplates()
                }
            } else if (responseStatusReport.from === 'deleteReportTemplate') {
                if (responseStatusReport.status === 'success') {
                    setAlert('Deleted Successfully', 'success')
                    formik.values.template_name = ''
                    formik.values.template = false
                    formik.values.report = 'active_user_management'
                    getAllReportTemplates()
                }
            }
        }
        clearResponseReport()
    }, [responseStatusReport])

    useEffect(() => {
        if (report_templates && report_templates.length) {
            const optionArr = report_templates.map((subcat) => {
                let subCategoryChanged = {}
                subCategoryChanged.show = subcat.template_name
                subCategoryChanged.value = subcat.report
                return subCategoryChanged
            })
            let customTemplates = {
                head: 'Custom Templates',
                options: optionArr,
            }

            const foundObject = props.report.data[0].groupoptions.find(
                (obj) => obj.head === 'Custom Templates'
            )
            if (foundObject) {
                foundObject.options = optionArr
            } else {
                props.report.data[0].groupoptions.unshift(customTemplates)
            }

            setReport(props.report ? { formik: formik, ...props.report } : {})
        } else {
            props.report.data[0].groupoptions =
                props.report.data[0].groupoptions.filter(
                    (obj) => obj.head != 'Custom Templates'
                )
            setReport(props.report ? { formik: formik, ...props.report } : {})
        }
    }, [report_templates, props.report])

    useEffect(() => {
        if (reports_data) {
            setReportsData(reports_data)
            console.log('reports_data', reports_data)
            setIsLoading(false)
            // toggleFullScreenPopup(true)
        }
    }, [reports_data])

    // useEffect(() => {
    //     formik.setFieldValue('end_date', formik.values.start_date)
    // }, [formik.values.start_date])

    useEffect(() => {
        if (
            formik.values.report === 'single_auction_product_management' ||
            formik.values.report === 'all_auction_bid_history_reports'
        ) {
            formikAuction.submitForm()
        } else {
            if (formik.values?.filters?.auctionid?.value) {
                formik.values.filters.auctionid.value = ''
            }
        }
    }, [formik.values.report])

    useEffect(() => {
        return () => {
            setIsLoading(false)
        }
    })

    useEffect(() => {
        props.additionalfieldUpdate(formik.values)
    }, [formik.values])

    const allSortOptions = [
        { id: 'asc', description: 'Ascending' },
        { id: 'desc', description: 'Descending' },
    ]

    const allSearchOptions = props.allSearchOptions

    const action = [
        {
            label: t('Action'),
            placeholder: t('Select Report Type'),
            class: 'col-12',
            type: 'select',
            options: [
                { value: 'display', show: 'Display' },
                { value: 'download', show: 'Download' },
            ],
            name: 'action',
            formik: formik,
        },
    ]

    const template = [
        {
            label: t('Template Name'),
            placeholder: t('Enter Tempalte Name'),
            class: `${formik.values.template ? '' : 'd-none'} col-sm-6 col-12`,
            type: '',

            name: 'template_name',
            formik: formik,
        },
    ]

    const withinRange = [
        {
            label: t('Within'),
            placeholder: t('Enter Within'),
            class: 'col-12',
            type: 'select',
            options: [
                { value: 'day', show: t('The Past Day') },
                { value: 'week', show: t('The Past Week') },
                { value: 'month', show: t('The Past Month') },
                { value: 'year', show: t('The Past Year') },
            ],
            name: 'within',
            formik: formik,
        },
    ]

    const auctionRange = {
        formik: formik,
        data: [
            {
                label: t('Auction'),
                placeholder: t('Select Auction'),
                type: 'select',
                class: `col-12`,
                options: tableBody?.map((opt) => {
                    let updatedObject = {}
                    updatedObject.value = opt.id
                    updatedObject.show = `${opt.title} (${opt.id})`
                    return updatedObject
                }),
                name: 'auctionid',
                filter: true,
            },
        ],
    }

    // const report = props.report ? { formik: formik, ...props.report } : {}
    const today = new Date()
    const currentYear = today.getFullYear()

    const dateRange = {
        formik: formik,
        data: [
            {
                label: t('Select Type'),
                placeholder: t('Select Type'),
                class: 'col',
                type: 'select',
                name: 'select_type',
                options: [
                    { value: 'single_date', show: t('Date') },
                    { value: 'date', show: t('Date Range') },
                    { value: 'yearly', show: t('Yearly') },
                    { value: 'quarterly', show: t('Quarterly') },
                    { value: 'monthly', show: t('Monthly') },
                ],
            },
            {
                label: t('Select Quarter'),
                placeholder: t('Select Quarter'),
                class: ` ${
                    formik.values?.select_type === 'quarterly' ? '' : 'd-none'
                } col-4 `,
                type: 'select',
                name: 'quarterly',
                options: [
                    { value: 'q1', show: t('Q1') },
                    { value: 'q2', show: t('Q2') },
                    { value: 'q3', show: t('Q3') },
                    { value: 'q4', show: t('Q4') },
                ],
            },
            {
                label: t('Select Month'),
                placeholder: t('Select Month'),
                class: ` ${
                    formik.values?.select_type === 'monthly' ? '' : 'd-none'
                } col-4 `,
                type: 'select',
                name: 'month',
                options: [
                    { value: '', show: t('Select Month') },
                    { value: '01', show: 'January' },
                    { value: '02', show: 'February' },
                    { value: '03', show: 'March' },
                    { value: '04', show: 'April' },
                    { value: '05', show: 'May' },
                    { value: '06', show: 'June' },
                    { value: '07', show: 'July' },
                    { value: '08', show: 'August' },
                    { value: '09', show: 'September' },
                    { value: '10', show: 'October' },
                    { value: '11', show: 'November' },
                    { value: '12', show: 'December' },
                ],
            },
            {
                label: t('Select Year'),
                placeholder: t('Select Year'),
                class: ` ${
                    formik.values?.select_type === 'monthly' ||
                    formik.values?.select_type === 'yearly' ||
                    formik.values?.select_type === 'quarterly'
                        ? ''
                        : 'd-none'
                } col-4 `,
                type: 'select',
                disabled: formik.values?.month !== '' ? false : true,
                name: 'year',
                options: [
                    { value: '', show: t('Select Year') },
                    { value: `${currentYear}`, show: `${currentYear}` },
                    { value: `${currentYear - 1}`, show: `${currentYear - 1}` },
                    { value: `${currentYear - 2}`, show: `${currentYear - 2}` },
                    { value: `${currentYear - 3}`, show: `${currentYear - 3}` },
                    { value: `${currentYear - 4}`, show: `${currentYear - 4}` },
                    { value: `${currentYear - 5}`, show: `${currentYear - 5}` },
                ],
            },
            {
                label: t('Date'),
                placeholder: t('Enter Date'),
                type: 'date',
                class: `customDateReport ${
                    formik.values?.select_type === 'single_date' ? '' : 'd-none'
                } col-auto `,
                name: 'single_date',
                disableFuture: true,
            },
            {
                label: t('From Date'),
                placeholder: t('Enter From date'),
                type: 'date',
                class: ` ${
                    formik.values?.select_type === 'date' ? '' : 'd-none'
                } col-4 `,
                name: 'start_date',
            },
            {
                label: t('End date'),
                placeholder: t('Enter End date'),
                type: 'date',
                class: ` ${
                    formik.values?.select_type === 'date' ? '' : 'd-none'
                } col-4 `,
                name: 'end_date',
            },
        ],
    }

    useEffect(() => {
        let selectValue = formik.values?.select_type
        if (selectValue) {
            if (selectValue === 'quarterly') {
                let quarterlyValue = formik.values?.quarterly
                let yearValue = formik.values?.year
                if (quarterlyValue !== '') {
                    if (!yearValue) {
                        const today = new Date()
                        const currentYear = today.getFullYear()
                        yearValue = currentYear
                    }
                    if (quarterlyValue === 'q1') {
                        formik.values.start_date = `01-01-${yearValue}`
                        formik.values.end_date = `03-31-${yearValue}`
                    } else if (quarterlyValue === 'q2') {
                        formik.values.start_date = `04-01-${yearValue}`
                        formik.values.end_date = `06-30-${yearValue}`
                    } else if (quarterlyValue === 'q3') {
                        formik.values.start_date = `07-01-${yearValue}`
                        formik.values.end_date = `09-30-${yearValue}`
                    } else if (quarterlyValue === 'q4') {
                        formik.values.start_date = `10-01-${yearValue}`
                        formik.values.end_date = `12-31-${yearValue}`
                    }
                }
            } else if (selectValue === 'yearly') {
                let yearValue = formik.values?.year
                if (yearValue && yearValue !== '') {
                    formik.values.start_date = `01-01-${yearValue}`
                    formik.values.end_date = `12-31-${yearValue}`
                }
            } else if (selectValue === 'monthly') {
                let monthValue = formik.values?.month
                let yearValue = formik.values?.year
                if (monthValue && monthValue !== '') {
                    let month = parseInt(monthValue)
                    let finalmonth = monthValue
                    const today = new Date()
                    const currentYear = today.getFullYear()

                    const lastDay = new Date(currentYear, month, 0).getDate()
                    const endDate = new Date(
                        currentYear,
                        month - 1,
                        lastDay
                    ).getDate()

                    if (yearValue !== '') {
                        formik.values.start_date = `${finalmonth}-01-${yearValue}`
                        formik.values.end_date = `${finalmonth}-${endDate}-${yearValue}`
                    } else {
                        formik.values.start_date = `${finalmonth}-01-${currentYear}`
                        formik.values.end_date = `${finalmonth}-${endDate}-${currentYear}`
                    }
                }
            }
        }
    }, [
        formik.values?.select_type,
        formik.values?.month,
        formik.values?.year,
        formik.values?.quarterly,
    ])

    const limitResult = props.limitResult
        ? { formik: formik, ...props.limitResult }
        : {}

    let formFields = props.formFields

    useEffect(() => {
        if (formik.values.report) {
            let selectedTemplate
            if (report_templates && report_templates.length) {
                selectedTemplate = report_templates.find(
                    (ele) => ele.report === formik.values.report
                )
            }

            if (selectedTemplate && Object.keys(selectedTemplate).length) {
                setTemplateId(selectedTemplate.id)
                setReportName(selectedTemplate.report_name)
                const string = selectedTemplate.additional_fields
                const obj = JSON.parse(string)
                formik.values.filters = obj.filters
                formik.values.fields = JSON.parse(selectedTemplate.fields)
                    ? JSON.parse(selectedTemplate.fields)
                    : []
                formik.values.template_name = selectedTemplate.template_name
                formik.values.search =
                    selectedTemplate.search == 0 ? 'within' : 'customSelection'
                formik.values.within =
                    selectedTemplate.search == 0
                        ? selectedTemplate.search_type
                        : ''
                formik.values.select_type =
                    selectedTemplate.search == 1
                        ? selectedTemplate.search_type
                        : ''
                formik.values.page = 1
                formik.values.order =
                    selectedTemplate.sort == 0 ? 'asc' : 'desc'
                formik.values.orderby = ''
                formik.values.searchterm = ''
                setIsTemplate(false)
            } else {
                formik.values.page = 1
                formik.values.order = 'asc'
                formik.values.orderby = ''
                formik.values.searchterm = ''
                setReportName(formik.values.report)
                setTemplateId(0)
                let valueSelected = []
                let fieldsToSort = formFields
                fieldsToSort
                    .filter(
                        (field) =>
                            field.group.indexOf(
                                formik.values.report.toString()
                            ) !== -1
                    )
                    .map((d, i) => valueSelected.push(d.field))
                formik.values.fields = valueSelected
                setResetForm(!resetForm)
                setReportsData(null)
                setIsTemplate(true)
            }
        }
        return () => {
            setReportsData(null)
        }
    }, [formik.values.report])

    const updateTemplate = () => {
        const values = formik.values
        const selectedTemplate = report_templates.find(
            (ele) => ele.report === formik.values.report
        )
        values.id = selectedTemplate.id
        values.report = reportName ? reportName : values.report
        reportTemplateAction(values)
    }

    const generateReport = (data) => {
        if (data === 'template') {
            formik.values.template = true
        } else {
            formik.values.template = false
        }

        formik.handleSubmit()
    }

    return (
        <div className="dashboard reportManagement">
            <ReportDisplay
                formik={formik}
                fieldsToShow={formFields}
                searchInfo={props.searchInfo}
                data={manage}
                function={toggleFullScreenPopup}
                hideCompactView={props.hideCompactView}
            />
            <form onSubmit={formik.handleSubmit} autoComplete="nofill">
                <h6 className="dashSubtitle">
                    {t(
                        'Report management gives you direct access of accounting overview based on the reporting you wish to formulate.'
                    )}
                </h6>
                <div className="reportAction d-flex align-items-center">
                    <div className="row">{Object.values(mapData(action))}</div>
                </div>
                {report ? (
                    <div className="reportAction d-flex align-items-center">
                        <div className="row">
                            {Object.values(mapData(report))}
                        </div>
                    </div>
                ) : null}

                <h6 className="dashSubtitle">
                    {props.customLabel ? props.customLabel : ''}
                </h6>

                <div className="reportAction d-flex align-items-center flex-wrap">
                    <div className="reportLabel">
                        <h6>{t('Fields')}</h6>
                    </div>

                    <div className="reportFields d-flex justify-content-start align-items-center flex-wrap">
                        {formFields
                            .filter(
                                (field) =>
                                    field.group.indexOf(
                                        reportName
                                            ? reportName
                                            : formik.values.report.toString()
                                    ) !== -1
                            )
                            .map((d, i) => (
                                <>
                                    <CheckBox
                                        name="fields"
                                        label={d.label}
                                        checked={
                                            formik.values.fields.indexOf(
                                                d.field.toString()
                                            ) !== -1
                                                ? true
                                                : false
                                        }
                                        value={d.field.toString()}
                                        onChange={formik.handleChange}
                                    />
                                </>
                            ))}
                    </div>
                </div>

                {formik.values.report === 'single_auction_product_management' ||
                formik.values.report === 'all_auction_bid_history_reports' ? (
                    <div className="reportAction d-flex align-items-center flex-wrap">
                        <div className="reportLabel">
                            <h6>{t('Select Auction')}</h6>
                        </div>
                        <div className="d-flex flex-wrap">
                            <div className="d-flex justify-content-center align-items-center">
                                {mapData(auctionRange)}
                            </div>
                        </div>
                        <div className="row">
                            {Object.values(mapData(template))}
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="reportAction d-flex align-items-center flex-wrap">
                            <div className="reportLabel">
                                <h6>{t('Search')}</h6>
                            </div>
                            <div className="d-flex flex-wrap">
                                <div className="d-flex justify-content-center align-items-center">
                                    <RadioBox
                                        items={allSearchOptions}
                                        value={formik.values.search}
                                        onChange={formik.handleChange}
                                        name="search"
                                    />
                                </div>
                                <div className="reportRange datePicker d-flex align-items-center">
                                    {formik.values.search === 'within' ? (
                                        <>
                                            <div className="row">
                                                {Object.values(
                                                    mapData(withinRange)
                                                )}
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <div className="row">
                                                {Object.values(
                                                    mapData(dateRange)
                                                )}
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="reportAction d-flex align-items-center flex-wrap">
                            <div className="reportLabel">
                                <h6>{t('Order Results')}</h6>
                            </div>
                            <div className="orderResults d-flex justify-content-center align-items-center">
                                <RadioBox
                                    items={allSortOptions}
                                    value={formik.values.order}
                                    onChange={formik.handleChange}
                                    name="order"
                                />
                            </div>
                        </div>{' '}
                        <div className="row">
                            {Object.values(mapData(template))}
                        </div>
                    </>
                )}

                {/* <div className="reportAction d-flex align-items-center">
                <div className="reportLabel">
                    <h6>Limit Results</h6>
                </div>
                <div className="limitResults">
                    <div className="row">{Object.values(mapData(limitResult))}</div>
                </div>
            </div> */}
                {isLoading && <div>Loading...</div>}
                <div className="actionButton d-flex  flex-wrap">
                    <PrimaryButton
                        id="report_generate"
                        type="submit"
                        label={t('Generate Report')}
                    />
                    {isTemplate ? (
                        <SecondaryButton
                            id="report_add"
                            onClick={() => {
                                generateReport('template')
                            }}
                            btnSize="ml-2"
                            // type="submit"
                            label={
                                formik.values.template
                                    ? t('Save Template')
                                    : t('Add Template')
                            }
                        />
                    ) : null}{' '}
                    {!isTemplate && templateId > 0 ? (
                        <>
                            <SecondaryButton
                                id="report_delete"
                                btnSize="ml-2"
                                onClick={() => {
                                    deleteReportTemplate({
                                        id: templateId,
                                    })
                                }}
                                // type="submit"
                                label={t('Delete Template')}
                            />
                            <SecondaryButton
                                id="report_update"
                                btnSize="ml-2"
                                onClick={() => {
                                    updateTemplate()
                                }}
                                // type="submit"
                                label={t('Update Template')}
                            />
                        </>
                    ) : null}
                </div>
            </form>
        </div>
    )
}

export default ReportComponent
